import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Contents from './components/Contents'
import AppHeader from './components/AppHeader';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';
import Login from './components/Login';
import Register from './components/Register';
import PrivateRoute from './components/PrivateRoute';
import { Layout } from 'antd';
import { MyContextProvider } from './components/MyContext';
import 'antd/dist/reset.css'; // ✅ Correct Ant Design reset styles
import ForgotPassword from './components/ForgetPassword';
import ResetPassword from './components/ResetPassword';
import SubscriptionRequired from './components/SubscriptionRequired';
import SubscriptionExpired from './components/SubscriptionExpired';
import SubscriptionError from './components/SubscriptionError';
const App = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);

  return (
    <MyContextProvider>
      <Router>
        <Layout style={{ minHeight: '100vh' }}>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:uidb64/:token" element={<ResetPassword />} />
            <Route path="/subscription-required" element={<SubscriptionRequired />} />
            <Route path="/subscription-expired" element={<SubscriptionExpired />} />
            <Route path="/subscription-error" element={<SubscriptionError />} />
            {/* Private Route for the dashboard */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Layout>
                    <AppHeader onSidebarToggle={setIsSidebarVisible} onShowContents={() => setIsHelpModalVisible(true)} />
                    <Layout>
                      {isSidebarVisible && <Sidebar />}
                      <MainContent />
                    </Layout>
                    <Contents visible={isHelpModalVisible} onClose={() => setIsHelpModalVisible(false)} />
                  </Layout>
                </PrivateRoute>
              }
            />

            {/* Redirect from the root to login */}
            <Route path="/" element={<Navigate to="/login" />} />
          </Routes>
        </Layout>
      </Router>
    </MyContextProvider>
  );
};

export default App;
